import { CoreEnum, NamedCoreEnum } from '../../Models';
import {
  DropdownDbOption,
  DropdownOption,
  DropdownValue,
} from 'v3/Components/Form/Dropdown';
import { TogglerItem } from 'v3/Components/Form/ItemsToggler';

export type DocumentModel = {
  fileId: string;
  fileName: string;
  size: string;
};

export type ClientReportQuestion = {
  id: string;
  question: string;
  answer?: string;
  isSelected: boolean;
};

export type AttendingProvider = {
  apName: string;
  apSpecialty: DropdownOption;
  apPhoneNumber: string;
  apEmail: string;
};

export class ReferralsRequest {
  id?: string;
  clientId?: string;
  skipValidation?: boolean;
  referralSourceId?: string;
  referralDate?: Date;
  firstName?: string;
  lastName?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  phone?: string;
  email?: string;
  specialInstructions?: string;
  gender?: DropdownValue;
  referralRequestDraftDocuments?: DocumentModel[];
  referralRequestDocuments?: DocumentModel[];
  dateOfBirth?: Date;
  dueDate?: Date;
  tat?: NamedCoreEnum;
  tatPriority?: DropdownValue;
  jurisditionalMatchRequired?: boolean | undefined;
  benefitState?: DropdownValue;
  requestedReviewerSpecialty?: DropdownValue;
  numberOfReviews: number | undefined;
  requestedReviewerSpecialties?: [];
  service?: DropdownDbOption;
  subService?: DropdownDbOption;
  attendingProviders?: AttendingProvider[];
  claimNumber?: string;
  referralNumber?: string;
  dateOfInjury?: Date;
  dateOfRequest?: Date;
  dateOfExam?: Date;
  employerName?: string;
  apContactPreference?: string;
  employerLocation?: string;
  employerZipCode?: string;
  medications?: [];
  clientReportQuestions?: TogglerItem[];
  additionalQuestions?: TogglerItem[];
  lineOfBusiness?: CoreEnum;
  status?: CoreEnum;
  draftStatus?: CoreEnum;
}
